import { UpdateSaleTypes } from './types';

export const updateSaless = (data: object) => {
  return {
    types: [
      UpdateSaleTypes.GET_UPDATE_SALE_REQUEST,
      UpdateSaleTypes.GET_UPDATE_SALE_SUCCESS,
      UpdateSaleTypes.GET_UPDATE_SALE_FAILURE,
    ],
    data,
    promise: (client: any) => client.post(`/api/controle_crm/sales_update_front`, { data }),
  };
};
